import React, { useState, useEffect, useRef, useContext } from "react";
import "./index.scss";
import Slider from "./slider";
import { useDispatch, useSelector } from "react-redux";
import { updatecount } from "../../action/adv";
import { HMS } from "../../constants/function";
import { Typography } from "@mui/material";

export default function AudPlayer({ url, image, type, href }) {
  const [percentage, setPercentage] = useState(0);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const audioRef = useRef();
  const dispatch = useDispatch();
  const { index, songs, track, prevIndex, pos } = useSelector(
    (state) => state.streamSong
  );

  const onChange = (e) => {
    const audio = audioRef.current;
    audio.currentTime = (audio.duration / 100) * e.target.value;
    setPercentage(e.target.value);
  };

  const getCurrDuration = (e) => {
    const percent = (
      (e.currentTarget.currentTime / e.currentTarget.duration) *
      100
    ).toFixed(2);
    const time = e.currentTarget.currentTime;

    setPercentage(+percent);
    setCurrentTime(time.toFixed());
  };

  const reverseDuration = () => {
    let reversedDuration = (duration - currentTime).toFixed();
    return reversedDuration;
  };

  useEffect(() => {
    const audio = audioRef.current;
    // const audio = new Audio(url);
    audio.play();
  });

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.addEventListener("ended", () => {
        if (track && songs.length > 0) {
          track.resumeProcessAudioBuffer();
          dispatch(updatecount(0));
        } else {
          dispatch(updatecount(0));
        }
      });
    }
  }, []);

  function handleSeeking(event) {
    const audio = audioRef.current;
    const currentTime = audio?.currentTime;
    // console.log(currentTime, "::CT::");
    const previousTime = event.target.dataset.previousTime;
    // console.log(previousTime, "::PT::");

    if (currentTime > previousTime) {
      audio.currentTime = previousTime;
    }
    event.target.dataset.previousTime = audio?.currentTime;
  }

  window.onkeydown = vidCtrl;

  function vidCtrl(e) {
    const vid = document.querySelector("audio");
    const key = e.code;

    if (key === "Space") {
      e.preventDefault();
      if (vid.play || vid.ended) {
        vid.pause(false);
      }
    }
  }
  const handleSkip = (duration) => {
    if (duration > 30) dispatch(updatecount(0));
  };
  return (
    <div className="_audio_ad_container">
      {type === "audio" ? (
        <div className="adu_time">
          <Typography
            className="fs-20"
            onClick={(e) => {
              e.stopPropagation();
              handleSkip(audioRef.current.currentTime);
            }}
          >
            {`${HMS(reverseDuration())}` === "undefined"
              ? "00 : 00"
              : audioRef.current.currentTime < 30
              ? `${HMS(reverseDuration())}`
              : "Skip"}
          </Typography>
        </div>
      ) : null}
      <a href={href} target="_blank" className="aud_ancer">
        <img src={image} alt="img" className="aud_img" />
        <div className="aud_bottom">
          <div className="aud_transferent"></div>
          <Slider percentage={percentage} onChange={onChange} />
          <audio
            ref={audioRef}
            onTimeUpdate={getCurrDuration}
            onLoadedData={(e) => {
              setDuration(e.currentTarget.duration.toFixed());
            }}
            src={url}
            onLoadedMetadata={reverseDuration}
            onSeeking={handleSeeking}
            autoPlay
          ></audio>
        </div>
      </a>
    </div>
  );
}
